// React
import { useEffect } from "react";
// Constants
import { SubRouteType } from "@ms/uno-constants/lib/local/RoutingConstants";
// Routing
import { extractPlanRoutingDetailsFromSubRoute } from "@ms/uno-routing";
import { Store } from "@ms/planner-stores/lib/local/stores/Store";
// Utilities
import { isOsMac } from "@ms/uno-utilities/lib/local/BrowserUtilities";
/**
 * Registers document-level keyboard shortcuts for undo (Ctrl+Z / Cmd+Z) and redo (Ctrl+Y / Cmd+Shift+Z).
 * Handles platform differences automatically (Windows/Linux vs Mac).
 * Only fires when the current view is a basic plan; uses the plan id as the container id.
 * @param acLoader Loader for action creators
 * @param storeLoader Loader for stores
 * @param configProvider Provider for app configuration (used to check the EnableUndoRedoInEvoPlans flight)
 */ export function useUndoRedoKeyboardHandler(acLoader, storeLoader, configProvider) {
    useEffect(()=>{
        if (!configProvider().flights.EnableUndoRedoInEvoPlans) {
            return;
        }
        const isMac = isOsMac();
        const onKeyDown = (event)=>{
            const routeStore = storeLoader.load(Store.Route);
            const subRouteType = routeStore.getCurrentSubRouteType();
            if (subRouteType !== SubRouteType.BasicPlan) {
                return;
            }
            const planRoutingDetails = extractPlanRoutingDetailsFromSubRoute(routeStore.getCurrentSubRoute(), subRouteType);
            const planId = planRoutingDetails?.planId;
            if (!planId) {
                return;
            }
            const key = event.key.toLowerCase();
            const isControlKeyPressed = event.ctrlKey;
            const isCommandKeyPressed = event.metaKey;
            if (!isControlKeyPressed && !isCommandKeyPressed || event.altKey || key !== "z" && key !== "y") {
                return;
            }
            // Undo: Ctrl+Z (Windows/Linux) or Cmd+Z (Mac)
            if (key === "z" && !event.shiftKey) {
                event.preventDefault();
            // TODO: Add Undo ActionCreator when its implemented
            } else if (!isMac && key === "y" || isMac && key === "z" && event.shiftKey) {
                event.preventDefault();
            // TODO: Add Redo ActionCreator when its implemented
            }
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>{
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        acLoader,
        storeLoader,
        configProvider
    ]);
}
